import keyMirror from '@kopapro-redux/utils/key-mirror';

export default keyMirror({
  GET_M18_COMBO_LIST_REQUEST: null,
  GET_M18_LOOKUP_LIST_REQUEST: null,
  COMBO_UPDATED: null,
  LOOKUP_UPDATED: null,
});
